import * as z from 'zod';
import {emailRegex} from '../../../shared/services/emailValidation';

// POST /3.0/users/signin
export const LoginSchema = z.object({
  email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください')
    .min(1, {message: '必須項目です'}),
  password: z.string().min(1, {message: '必須項目です'}),
});

export const LoginResponseSchema = z.object({
  accessToken: z.string(),
  accessTokenExpiresIn: z.string(), // ISO 8601形式の文字列
  refreshToken: z.string(),
  refreshTokenExpiresIn: z.string(), // ISO 8601形式の文字列
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
